import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { firestore } from '../../../../services/firebase';
import {
  CATALOG_SETTINGS_DOC,
  CUSTOMIZATION,
} from '../../../../constants/catalogVitrineSettings';
import {
  pickCatalogVitrineFields,
  resolveCatalogVitrineSettings,
} from '../../../../utils/resolveCatalogVitrineSettings';

const SETTINGS = 'settings';

async function readLegacyFilterByUserProducts() {
  try {
    const settingsSnap = await getDoc(doc(firestore, CUSTOMIZATION, SETTINGS));
    if (!settingsSnap.exists()) return undefined;
    if (typeof settingsSnap.data().filterByUserProducts !== 'boolean') {
      return undefined;
    }
    return settingsSnap.data().filterByUserProducts;
  } catch {
    return undefined;
  }
}

export async function loadCatalogVitrineSettings() {
  const [catalogSnap, legacy] = await Promise.all([
    getDoc(doc(firestore, CUSTOMIZATION, CATALOG_SETTINGS_DOC)),
    readLegacyFilterByUserProducts(),
  ]);
  return resolveCatalogVitrineSettings(catalogSnap, legacy);
}

export async function saveCatalogVitrineSettings(settings) {
  const fields = pickCatalogVitrineFields(settings);
  await setDoc(
    doc(firestore, CUSTOMIZATION, CATALOG_SETTINGS_DOC),
    {
      ...fields,
      configuredViaCatalogModal: true,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
}
